import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08ac3bf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_topup_credit",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-content",
  style: {"border-radius":"16px"}
}
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { style: {"position":"relative","height":"50px"} }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center flex-column"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"success-animation\" data-v-08ac3bf2><svg class=\"checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\" data-v-08ac3bf2><circle class=\"checkmark__circle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\" data-v-08ac3bf2></circle><path class=\"checkmark__check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\" data-v-08ac3bf2></path></svg></div><div style=\"font-weight:600;margin-top:30px;font-size:24px;color:#7ebf50;\" data-v-08ac3bf2> SUCCESS! </div><div style=\"font-weight:500;font-size:14px;margin-top:5px;\" data-v-08ac3bf2> You’ve successfully top up. </div>", 3)
const _hoisted_14 = [
  _hoisted_11
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = { class: "d-flex justify-content-end mt-10" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { style: {"text-align":"center"} }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"300px","color":"#7e8299","font-weight":"500","text-align":"center"} }, [
    /*#__PURE__*/_createTextVNode(" Scan this QR code to get "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ffd600","font-weight":"bold"} }, "WE Credit")
  ])
], -1))
const _hoisted_24 = { class: "mt-5 d-flex justify-content-center" }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","color":"#6a6266","font-weight":"500"} }, " Amount ", -1))
const _hoisted_27 = { class: "body__form__input" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CREDIT", -1))
const _hoisted_29 = {
  key: 0,
  style: {"color":"#f44336"}
}
const _hoisted_30 = { class: "body__credit__item" }
const _hoisted_31 = { style: {"margin-top":"2vh"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Note", -1))
const _hoisted_33 = { class: "body__form__input" }
const _hoisted_34 = { class: "d-flex justify-content-end mt-10" }
const _hoisted_35 = {
  class: "modal fade",
  id: "kt_modal_topup_bank",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_36 = {
  class: "modal-content",
  style: {"border-radius":"16px"}
}
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { style: {"position":"relative","height":"50px"} }
const _hoisted_39 = { class: "modal-title" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Full Name(TH)", -1))
const _hoisted_45 = { style: {"color":"red"} }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bank Number", -1))
const _hoisted_47 = { style: {"color":"red"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bank Name", -1))
const _hoisted_49 = ["src"]
const _hoisted_50 = { style: {"margin-left":"10px"} }
const _hoisted_51 = { style: {"color":"red","margin-left":"10px"} }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ID Card / Juristic ID", -1))
const _hoisted_53 = { style: {"color":"red"} }
const _hoisted_54 = { style: {"color":"red"} }
const _hoisted_55 = { class: "mb-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "formFile",
  class: "form-label"
}, "Document ID card / Company certificate", -1))
const _hoisted_57 = { style: {"color":"red"} }
const _hoisted_58 = { class: "mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "formFile",
  class: "form-label"
}, "Document Bank", -1))
const _hoisted_60 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","padding":"30px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/checktrue.svg",
    style: {"width":"120px","height":"120px"}
  })
], -1))
const _hoisted_63 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("succeed")
const _hoisted_65 = {
  class: "modal fade",
  id: "kt_modal_topup_default_bank",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_66 = {
  class: "modal-content",
  style: {"border-radius":"16px"}
}
const _hoisted_67 = { class: "modal-body" }
const _hoisted_68 = { style: {"position":"relative","height":"50px"} }
const _hoisted_69 = { class: "modal-title" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { style: {"max-height":"60vh","overflow":"auto"} }
const _hoisted_75 = ["src"]
const _hoisted_76 = { style: {"margin-left":"10px"} }
const _hoisted_77 = { style: {"margin-left":"10px"} }
const _hoisted_78 = { style: {"margin-left":"10px"} }
const _hoisted_79 = ["value"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","padding":"30px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/checktrue.svg",
    style: {"width":"120px","height":"120px"}
  })
], -1))
const _hoisted_81 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_82 = /*#__PURE__*/_createTextVNode("succeed")
const _hoisted_83 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_84 = { style: {"color":"red"} }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "modal-dialog modal-md",
        style: _normalizeStyle({
          marginTop:
            _ctx.isTopUp == false || _ctx.isCancel == true || _ctx.isSuccess == true
              ? '20vh'
              : '',
        })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.isCancel == true
                    ? "Do you want to cancel this Top up ?"
                    : _ctx.isTopUp == false
                    ? "Top up"
                    : ""), 1),
              (
                  _ctx.isTopUp == true && _ctx.isCancel == false && _ctx.isSuccess == false
                )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCancel = true)),
                    style: {"position":"absolute","top":"0px","right":"0px"}
                  }, _hoisted_7))
                : (_ctx.isCancel == false)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                      "data-bs-dismiss": "modal",
                      style: {"position":"absolute","top":"0px","right":"0px"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reset()))
                    }, _hoisted_9))
                  : _createCommentVNode("", true)
            ]),
            (_ctx.isSuccess == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
              : (_ctx.isCancel == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", {
                        class: "body__button",
                        style: {
                    backgroundColor: 'white',
                    color: 'red',
                    cursor: 'pointer',
                  },
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCancel = false))
                      }, " CANCEL "),
                      _createElementVNode("div", {
                        class: "body__button",
                        style: {
                    backgroundColor: '#FFD600',
                    cursor: 'pointer',
                    color: 'black',
                  },
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reset())),
                        "data-bs-dismiss": "modal"
                      }, " CONFIRM ")
                    ])
                  ]))
                : (_ctx.isLoading == true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      style: _normalizeStyle([{ height: _ctx.isTopUp == true ? '70vh' : '40vh' }, {"overflow":"auto","display":"flex","align-items":"center","justify-content":"center"}])
                    }, _hoisted_19, 4))
                  : (_ctx.isTopUp == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("img", {
                            src: _ctx.QrUrl,
                            alt: "",
                            srcset: "",
                            style: {"max-height":"70vh","max-width":"100%"}
                          }, null, 8, _hoisted_22)
                        ]),
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", {
                            class: "body__button",
                            style: {
                    backgroundColor: 'black',
                    cursor: 'pointer',
                    width: '150px',
                    textAlign: 'center',
                  },
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkStatusTopup()))
                          }, " CONFIRM ")
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control form-control",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.amountTopup) = $event)),
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.amountTopupCheck()))
                          }, null, 544), [
                            [_vModelText, _ctx.amountTopup]
                          ]),
                          _hoisted_28
                        ]),
                        _createElementVNode("div", null, [
                          (_ctx.checknumber)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Please input amount more than 2,000 "))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_row, { class: "mt-5" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditItemList, (creditItem) => {
                              return (_openBlock(), _createBlock(_component_el_col, {
                                span: 24,
                                sm: 8,
                                key: creditItem,
                                class: "d-flex justify-content-center",
                                onClick: ($event: any) => (_ctx.clickToSetAmount(creditItem)),
                                style: {"cursor":"pointer"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_30, _toDisplayString(creditItem), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control form-control",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.amountNote) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.amountNote]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          (parseFloat(_ctx.amountTopup) < 2000)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: "",
                                class: "body__button",
                                style: _normalizeStyle({
                    backgroundColor:
                      parseFloat(_ctx.amountTopup) < 2000 || _ctx.amountTopup == ''
                        ? '#D8D8D8'
                        : '#1a1a27',
                    cursor:
                      parseFloat(_ctx.amountTopup) < 2000 || _ctx.amountTopup == ''
                        ? ''
                        : 'pointer',
                  }),
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.topUp()))
                              }, " CONTINUE ", 4))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "body__button",
                                style: _normalizeStyle({
                    backgroundColor:
                      parseFloat(_ctx.amountTopup) < 2000 || _ctx.amountTopup == ''
                        ? '#D8D8D8'
                        : '#1a1a27',
                    cursor:
                      parseFloat(_ctx.amountTopup) < 2000 || _ctx.amountTopup == ''
                        ? ''
                        : 'pointer',
                  }),
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.topUp()))
                              }, " CONTINUE ", 4))
                        ])
                      ]))
          ])
        ])
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", {
        class: "modal-dialog modal-md",
        style: _normalizeStyle({
          marginTop:
            _ctx.isTopUp == false || _ctx.isCancel == true || _ctx.isSuccess == true
              ? '20vh'
              : '',
        })
      }, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.isCancel == true
                    ? "Do you want to cancel this Top up ?"
                    : _ctx.isTopUp == false
                    ? "Create Bank"
                    : ""), 1),
              (
                  _ctx.isTopUp == true && _ctx.isCancel == false && _ctx.isSuccess == false
                )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isCancel = true)),
                    style: {"position":"absolute","top":"0px","right":"0px"}
                  }, _hoisted_41))
                : (_ctx.isCancel == false)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                      "data-bs-dismiss": "modal",
                      style: {"position":"absolute","top":"0px","right":"0px"},
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.reset()))
                    }, _hoisted_43))
                  : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _hoisted_44,
                  _createElementVNode("small", _hoisted_45, _toDisplayString(_ctx.errorName), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formInput.nameName,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formInput.nameName) = $event)),
                    maxlength: "50",
                    placeholder: "Full name",
                    "show-word-limit": "",
                    type: "text",
                    onKeyup: _ctx.checkValue
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _hoisted_46,
                  _createElementVNode("small", _hoisted_47, _toDisplayString(_ctx.errorNumber) + _toDisplayString(_ctx.errorNumberChange), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formInput.bankNumber,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formInput.bankNumber) = $event)),
                    type: "number",
                    onKeyup: _ctx.checkValueText
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _hoisted_48,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formInput.bankName,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formInput.bankName) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.get_name_bank, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          value: item.bank_id,
                          label: item.bank_name_th
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: item.bank_icon,
                              style: {"width":"30px"}
                            }, null, 8, _hoisted_49),
                            _createElementVNode("span", _hoisted_50, _toDisplayString(item.bank_name_th), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("small", _hoisted_51, _toDisplayString(_ctx.errorBankname), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _hoisted_52,
                  _createElementVNode("small", _hoisted_53, _toDisplayString(_ctx.erroridCardChange) + _toDisplayString(_ctx.erroridCard), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formInput.idCard,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formInput.idCard) = $event)),
                    type: "number",
                    onKeyup: _ctx.checkValueTextID
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _: 1
              }),
              _createElementVNode("small", _hoisted_54, _toDisplayString(_ctx.errorDocBankId), 1),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                (_openBlock(), _createElementBlock("input", {
                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                  class: "form-control",
                  type: "file",
                  id: "formFile",
                  accept: ".jpg, .jpeg, .png",
                  ref: "fileupload",
                  key: _ctx.fileInputKey
                }, null, 32))
              ]),
              _createElementVNode("small", _hoisted_57, _toDisplayString(_ctx.errorDocBank), 1),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                (_openBlock(), _createElementBlock("input", {
                  onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleFileUploadImg && _ctx.handleFileUploadImg(...args))),
                  class: "form-control",
                  type: "file",
                  id: "formFile",
                  accept: ".jpg, .jpeg, .png",
                  key: _ctx.fileInputKey
                }, null, 32))
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.onSubmit
                    }, {
                      default: _withCtx(() => [
                        _hoisted_61
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.nextPage == true]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_62,
              _createElementVNode("div", _hoisted_63, [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.reset()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_64
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.nextPage == false]
            ])
          ])
        ])
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", {
        class: "modal-dialog modal-md",
        style: _normalizeStyle({
          marginTop:
            _ctx.isTopUp == false || _ctx.isCancel == true || _ctx.isSuccess == true
              ? '20vh'
              : '',
        })
      }, [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("h2", _hoisted_69, _toDisplayString(_ctx.isCancel == true
                    ? "Do you want to cancel this Top up ?"
                    : _ctx.isTopUp == false
                    ? "Set Default Bank"
                    : ""), 1),
              (
                  _ctx.isTopUp == true && _ctx.isCancel == false && _ctx.isSuccess == false
                )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isCancel = true)),
                    style: {"position":"absolute","top":"0px","right":"0px"}
                  }, _hoisted_71))
                : (_ctx.isCancel == false)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                      "data-bs-dismiss": "modal",
                      style: {"position":"absolute","top":"0px","right":"0px"},
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.reset()))
                    }, _hoisted_73))
                  : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_input, {
                  clearable: "",
                  modelValue: _ctx.searchBank.bank_text_default,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.searchBank.bank_text_default) = $event)),
                  placeholder: "Search bank name / bank number / name",
                  style: {"width":"23vw"},
                  "value-key": "name"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Search)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchankList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {"display":"flex","justify-content":"space-between","padding":"25px"}
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: item.bank_manager_bank.bank_icon,
                      style: {"width":"30px"}
                    }, null, 8, _hoisted_75),
                    _createElementVNode("label", _hoisted_76, [
                      _createTextVNode(_toDisplayString(item.bank_manager_bank.bank_name_en), 1),
                      _createElementVNode("span", _hoisted_77, "*" + _toDisplayString(item.bank_manager_bank_number.substr(
                          item.bank_manager_bank_number.length - 4
                        )), 1),
                      _createElementVNode("span", _hoisted_78, _toDisplayString(item.bank_manager_customer_name.substr(0, 6)), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      style: {"margin-left":"10px"},
                      type: "radio",
                      value: item.bank_manager_id,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.defaultBank) = $event))
                    }, null, 8, _hoisted_79), [
                      [
                        _vModelRadio,
                        _ctx.defaultBank,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.nextPage == true]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_80,
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.reset()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_82
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.nextPage == false]
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", null, [
              _createElementVNode("small", _hoisted_84, _toDisplayString(_ctx.errorRadio), 1),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onSubmitRadio
                  }, {
                    default: _withCtx(() => [
                      _hoisted_85
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, _ctx.nextPage == true]
          ])
        ])
      ], 4)
    ])
  ]))
}